import { Pipe, PipeTransform } from '@angular/core';
import { MediaFile } from '@core/models/media-file.model';


@Pipe({
    name: 'mediaIcon',
    standalone: false
})
export class FindMediaIconPipe implements PipeTransform {

    transform(item: MediaFile): string {
        let result = { icon: 'folder', type: 'Map' };
        const extension = item.path.split('.').pop();
        
            switch (extension) {
                case 'jpg':
                case 'jpeg':
                case 'png':
                case 'gif':
                case 'webp':
                    result = { icon: '', type: 'Afbeelding' };
                    break;
                case 'mp4':
                case 'm4a':
                case 'mov':
                case 'mpeg':
                case 'avi':
                case 'mkv':
                case 'webm':
                case 'ogg':
                case 'ogv':
                    result = { icon: 'play_arrow', type: 'Video' };
                    break;
                case 'mp3':
                case 'wav':
                case 'flac':
                case 'aac':
                case 'wma':
                    result = { icon: 'audiotrack', type: 'Audio' };
                    break;
                default:
                    result = { icon: 'insert_drive_file', type: 'Bestand' };
                    break;
            }
        
        return result.icon;
    }

}
